import { init } from './init'

export const mutations = Object.assign({}, init)
